import {useContext} from 'react';
import {RootContext} from '../context/root-context';

export const useLocale = () => {
  const {locale} = useContext(RootContext);
  return locale;
};
